export default "__VITE_ASSET___Hgj6Y65__"